import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useServiceNavigation from "../utility/useServiceNavigation";
// import LanguageDropdown from "../utility/LanguageDropdown";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import {
  FaHome,
  FaBlog,
  FaAddressBook,
  FaInfoCircle,
  FaUserMd,
  FaGraduationCap,
  FaFolder,
  FaAngleRight,
} from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa";

const MainMenu = ({
  menuItems,
  onServicesClick,
  subMenuItems,
  toggleMobileMenu,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [activePanel, setActivePanel] = useState("main");
  const [menuHistory, setMenuHistory] = useState([]);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);
  const { handleServiceClick } = useServiceNavigation();

  const iconMap = {
    Home: <FaHome />,
    Blog: <FaBlog />,
    "Contact us": <FaAddressBook />,
    About: <FaInfoCircle />,
    Services: <FaUserMd />,
    Training: <FaGraduationCap />,
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const navigateToPanel = (panelName, submenu = null) => {
    setMenuHistory([...menuHistory, activePanel]);
    setActivePanel(panelName);
    if (submenu) setCurrentSubmenu(submenu);
  };

  const navigateBack = () => {
    if (menuHistory.length > 0) {
      const previousPanel = menuHistory[menuHistory.length - 1];
      setMenuHistory(menuHistory.slice(0, -1));
      setActivePanel(previousPanel);

      if (previousPanel.startsWith("services-")) {
        setCurrentSubmenu(
          subMenuItems.find(
            (submenu, index) => `services-${index}` === previousPanel
          )
        );
      } else if (previousPanel.startsWith("child-")) {
        setCurrentSubmenu(
          currentSubmenu?.children?.find(
            (child, index) => `child-${index}` === previousPanel
          )
        );
      } else {
        setCurrentSubmenu(null);
      }
    }
  };

  const renderMainMenu = () => (
    <ul className="mobile-menu__list">
      {menuItems.map((item, index) => (
        <li key={index} className="mobile-menu__item mt-3">
          {item?.name === "Services" ? (
            <Link
              className="mobile-menu__link mobile-menu__link--expandable shadow-effect d-flex align-items-center mb-2 mt-2"
              onClick={(e) => {
                e.preventDefault();
                navigateToPanel("services");
              }}
            >
              <span className="d-flex align-items-center py-2">
                <span
                  className="d-flex align-items-center justify-content-center rounded-circle shadow"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  {iconMap[item.name] || <FaFolder />}
                </span>
                <span className="ms-2">{item.name}</span>
              </span>
              <FaAngleRight className="ms-auto" />
            </Link>
          ) : (
            <Link
              to={item?.link}
              className="mobile-menu__link shadow-effect d-flex align-items-center"
              onClick={() => {
                toggleMobileMenu();
              }}
            >
              <span className="d-flex align-items-center mb-2">
                <span
                  className="d-flex align-items-center justify-content-center rounded-circle shadow"
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  {iconMap[item.name] || <FaFolder />}
                </span>
                <span className="ms-2">{item.name}</span>
              </span>
            </Link>
          )}
        </li>
      ))}
    </ul>
  );

  const renderServicesMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>
      <ul className="mobile-submenu__list">
        {subMenuItems?.map((submenu, index) => (
          <li key={index} className="mobile-submenu__item">
            {submenu?.children?.length > 0 ? (
              <div
                className="mobile-submenu__link mobile-submenu__link--expandable d-flex align-items-center shadow-effect"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToPanel(`services-${index}`, submenu);
                }}
                style={{ marginBottom: "12px", padding: "15px 15px" }} // Increased spacing
              >
                {submenu?.thumbnail ||
                  (submenu?.icons && (
                    <span
                      className="d-flex justify-content-center align-items-center rounded-circle shadow-icon"
                      style={{
                        width: "36px",
                        height: "36px",
                        backgroundColor: "#fff",
                        border: "1px solid #c69933",
                      }}
                    >
                      <img
                        src={
                          submenu?.thumbnail || "https://via.placeholder.com/30"
                        }
                        alt="Avatar"
                        className="rounded-circle"
                        width="24"
                        height="24"
                      />
                    </span>
                  ))}
                <span className="ms-2">{submenu.name}</span>
                <FaAngleRight className="ms-auto" />
              </div>
            ) : (
              <Link to={submenu.path} className="mobile-submenu__link">
                {submenu.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const renderChildMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>
      <h3 className="mobile-submenu__title">{currentSubmenu?.name}</h3>
      <ul className="mobile-submenu__list">
        {currentSubmenu?.children?.map((child, index) => (
          <li key={index} className="mobile-submenu__item">
            {child?.children?.length > 0 ? (
              <div
                className="mobile-submenu__link mobile-submenu__link--expandable d-flex align-items-center shadow-effect"
                onClick={(e) => {
                  e.preventDefault();
                  navigateToPanel(`child-${index}`, child);
                }}
                style={{ marginBottom: "12px", padding: "15px 15px" }}
              >
                <span
                  className="d-flex justify-content-center align-items-center rounded-circle shadow-icon"
                  style={{
                    width: "36px",
                    height: "36px",
                    backgroundColor: "#fff",
                    border: "1px solid #c69933",
                  }}
                >
                  <img
                    src={child?.icons || "https://via.placeholder.com/30"}
                    alt="Avatar"
                    className="rounded-circle"
                    width="25"
                    height="25"
                  />
                </span>
                <span className="ms-2">{child.name}</span>
                <FaAngleRight className="ms-auto" />
              </div>
            ) : (
              <Link to={child?.path} className="mobile-submenu__link">
                {child.name}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const renderNestedMenu = () => (
    <div className="mobile-submenu">
      <button className="mobile-submenu__back" onClick={navigateBack}>
        <FaChevronLeft className="fs-1" />
        Back
      </button>
      <h3 className="mobile-submenu__title">{currentSubmenu?.name}</h3>
      <ul className="mobile-submenu__list">
        {currentSubmenu?.children?.map((nestedChild, index) => (
          <li
            key={index}
            className="mobile-submenu__item"
            style={{ padding: "5px 0" }}
          >
            <Link
              className="mobile-submenu__link shadow-effect"
              onClick={(e) => {
                e.preventDefault();
                toggleMobileMenu();
                handleServiceClick(nestedChild?.name, nestedChild?.link);
              }}
            >
              {nestedChild.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="">
      {!isMobile ? (
        <>
          <div className="d-flex justify-content-center align-items-center">
            <ul className="d-flex gap-4 list-unstyled align-items-center mt-4 mr-4">
              {menuItems.map((item, index) => (
                <li
                  key={index}
                  className={
                    item.children && item.children.length > 0 ? "" : ""
                  }
                >
                  {item?.name === "Services" ? (
                    <Link
                      onClick={(e) => {
                        e.preventDefault();
                        onServicesClick();
                      }}
                      className="fw-semibold text-decoration-none menu-link "
                    >
                      {item.name}
                      <MdKeyboardArrowDown className="fs-4" />
                    </Link>
                  ) : (
                    <Link
                      className="fw-semibold text-decoration-none menu-link "
                      to={item?.link}
                    >
                      {item.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>

            <Link
              to="/contact"
              className="btn-custom d-inline-flex align-items-center gap-2 mx-4 text-decoration-none"
            >
              <span>Contact Now</span>
              <MdOutlineKeyboardDoubleArrowRight className="fs-3" />
            </Link>
            {/* <LanguageDropdown /> */}
          </div>
        </>
      ) : (
        <div className="mobile-menu">
          <div className="mobile-menu__panels">
            <div
              className={`mobile-menu__panel ${
                activePanel === "main" ? "active" : ""
              }`}
            >
              {renderMainMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel === "services" ? "active" : ""
              }`}
            >
              {renderServicesMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel.startsWith("services-") ? "active" : ""
              }`}
            >
              {renderChildMenu()}
            </div>
            <div
              className={`mobile-menu__panel ${
                activePanel.startsWith("child-") ? "active" : ""
              }`}
            >
              {renderNestedMenu()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainMenu;
